import {
  ToastState,
  ToastItem,
  ToastOptions,
  ToastGettersTree,
  ToastMutationsTree,
  ToastActionsTree
} from '../types/modules/toast'

function generateId (): string {
  return `toast-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
}

const defaultOptions: Partial<ToastItem> = {
  type: 'info',
  location: 'bottom-right',
  textPosition: 'left',
  timeout: 5,
  canClose: true
}

const state: ToastState = {
  queue: [],
  current: null
}

const getters: ToastGettersTree = {
  currentToast: ({ current }) => current,
  queueLength: ({ queue }) => queue.length,
  isVisible: ({ current }) => current !== null
}

const mutations: ToastMutationsTree = {
  enqueue (state, toast: ToastItem) {
    state.queue.push(toast)
  },
  dequeue (state) {
    state.queue.shift()
  },
  setCurrent (state, toast: ToastItem | null) {
    state.current = toast
  },
  clear (state) {
    state.queue = []
    state.current = null
  }
}

const actions: ToastActionsTree = {
  show ({ commit, state: toastState }, options: ToastOptions) {
    const toast: ToastItem = {
      ...defaultOptions,
      ...options,
      id: generateId()
    }

    commit('enqueue', toast)

    if (!toastState.current) {
      const next = toastState.queue[0]
      commit('dequeue')
      commit('setCurrent', next)
    }
  },
  close ({ commit, state: toastState }) {
    commit('setCurrent', null)

    if (toastState.queue.length > 0) {
      const next = toastState.queue[0]
      commit('dequeue')
      commit('setCurrent', next)
    }
  },
  clear ({ commit }) {
    commit('clear')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
// eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any
